﻿import { SecurityRow } from "@/ServerTypes/Data/SecurityRow";
import { Decorators, TemplatedDialog } from "@serenity-is/corelib";
import { text, notifyWarning } from "@serenity-is/corelib/q";
import { SecurityPickerGrid } from "./SecurityPickerGrid";

@Decorators.registerClass("Matrix.Data.SecurityPickerDialog")
export class SecurityPickerDialog extends TemplatedDialog<any> {

	private pickerGrid: SecurityPickerGrid;

	constructor() {
		super();

		this.pickerGrid = new SecurityPickerGrid(this.byId("PickerGrid"));
		this.dialogTitle = "Select Securities";
	}

	public allowClear: boolean;

	protected getTemplate() {
		return `<div id="~_PickerGrid"></div>`;
	}

	protected getDialogOptions() {
		var opt = super.getDialogOptions();
		opt.buttons = [
			{
				text: text("Dialogs.OkButton"),
				click: () => {
					var selected = this.pickerGrid.selectedItems;
					if (!this.allowClear && !selected.length) {
						notifyWarning("Please select securities");
						return;
					}

					if (!this.onSuccess || this.onSuccess(selected))
						this.dialogClose();
				}
			},
			{
				text: text("Dialogs.CancelButton"),
				click: () => {
					this.dialogClose();
				}
			}
		];
		return opt;
	}

	get selectedItems() {
		return this.pickerGrid.selectedItems;
	}

	get value() {
		return this.pickerGrid.value;
	}

	set value(value: string[]) {
		this.pickerGrid.value = value;
	}

	set criteria(value: any[]) {
		this.pickerGrid.criteria = value;
	}

	public onSuccess: (selected: SecurityRow[]) => boolean;
}
